import { makeStatusCellRenderer } from 'components/shared/Blotter/Grid/CellRenderers/StatusCellRenderer';
import { ColorLevel } from 'types/sgBootstrap';

function getTradeAuthorizationStatusFieldColor(status: string): ColorLevel {
  switch (status) {
    case 'Granted':
      return 'success';
    case 'Denied':
      return 'danger';
    case 'DerogationRequired':
      return 'warning';
    default:
      return 'secondary';
  }
}

export const TradeAuthorizationStatusCellRenderer = makeStatusCellRenderer(getTradeAuthorizationStatusFieldColor);
